export default theme => ({
  timeline: {
    overflow: "scroll hidden",
  },
  timeline__contents: {
    display: "grid",
    position: "relative",
    height: "auto",
  },
  timeline__container: {
    display: "flex",
  },
  timeline__buttons: {
    display: "grid",
    marginTop: 11,
    gridAutoRows: "minmax(min-content, max-content)",
  },
  "timeline--preview": {
    display: "none",
  },
  timeline__add_button: {
    marginRight: theme.spacing(1) + 2,
    height: 50,
    padding: 0,
    marginBottom: 12,
  },
  timeline__add_icon: {
    fontSize: 20,
  },
});
